import hasTargetingChanged from "./hasTargetingChanged";

export default (prevProps, currentProps) => {
  const targetingHasChanged = hasTargetingChanged(prevProps, currentProps);
  const priorProductsHaveChanged =
    prevProps.priorProductsFingerprint !==
    currentProps.priorProductsFingerprint;
  const viewPortHasUpdated =
    prevProps.sizeMappingIndex !== null &&
    prevProps.sizeMappingIndex !== currentProps.sizeMappingIndex;
  const needsRefresh =
    targetingHasChanged || priorProductsHaveChanged || viewPortHasUpdated;

  return {
    needsRefresh,
    targetingHasChanged
  };
};
